import React, { useState, useContext, useEffect } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import { Container, Nav, Form, InputGroup } from "react-bootstrap";
import {
  Menu,
  User,
  Search,
  Heart,
  ShoppingBag,
  MapPin,
  Home,
} from "lucide-react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";
import { motion, AnimatePresence } from "framer-motion";

function Header() {
  const [searchText, setSearchText] = useState("");
  const [showSearchModal, setShowSearchModal] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const { categories } = useContext(CategoryContext);
  const [openId, setOpenId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleToggle = (id) => {
    setOpenId(openId === id ? null : id);
  };

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  return (
    <>
      {/* top bar */}
      <div
        className="d-none d-lg-block w-100 py-2"
        style={{
          backgroundColor: "var(--text-primary)",
          borderBottom: "1px solid rgba(0,0,0,0.03)",
        }}
      >
        <div className="container d-flex justify-content-between align-items-center">
          <span
            className="small text-light"
            style={{ fontSize: "10px", letterSpacing: "1px" }}
          >
            {/* <MapPin size={10} className="me-1" /> {config?.address?.district},{" "} */}
           Modern Grace Indian Soul. 
            {/* {config?.address?.state} */}
          </span>
          <ul className="custom-topbar-social-list">
            {config?.socialMedia?.facebook && (
              <li>
                <a
                  href={config?.socialMedia?.facebook}
                  target="_blank"
                  rel="noreferrer"
                  className="custom-topbar-social-link"
                >
                  <FaFacebook size={14} />
                </a>
              </li>
            )}

            {config?.socialMedia?.instagram && (
              <li>
                <a
                  href={config?.socialMedia?.instagram}
                  target="_blank"
                  rel="noreferrer"
                  className="custom-topbar-social-link"
                >
                  <FaInstagram size={14} />
                </a>
              </li>
            )}

            {config?.socialMedia?.twitter && (
              <li>
                <a
                  href={config?.socialMedia?.twitter}
                  target="_blank"
                  rel="noreferrer"
                  className="custom-topbar-social-link"
                >
                  <FaTwitter size={14} />
                </a>
              </li>
            )}

            {config?.socialMedia?.youtube && (
              <li>
                <a
                  href={config?.socialMedia?.youtube}
                  target="_blank"
                  rel="noreferrer"
                  className="custom-topbar-social-link"
                >
                  <FaYoutube size={14} />
                </a>
              </li>
            )}

            {config?.socialMedia?.linkedin && (
              <li>
                <a
                  href={config?.socialMedia?.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="custom-topbar-social-link"
                >
                  <FaLinkedin size={14} />
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>

      {/* main header */}
      <header
        className={`ethnic-header sticky-top ${scrolled ? "shadow-sm border-bottom" : ""}`}
      >
        <div className="container">
          <div className="row align-items-center py-1">
            <div className="col-3 col-lg-2">
              <Link to="/" className="brand-identity text-decoration-none">
                <img src={config?.logo} />
              </Link>
            </div>

            <div className="col-6 col-lg-7 text-center">
              <div className="d-none d-lg-flex gap-3">
                <Nav.Link
                  as={Link}
                  to="/"
                  className="custom-header-link d-none d-lg-flex"
                >
                  Home
                </Nav.Link>
                <div className="custom-nav-dropdown">
                  <Nav.Link as={Link} to="/" className="custom-header-link">
                    About
                  </Nav.Link>
                  <div className="custom-dropdown-menu">
                    <Link to="/about-us" className="custom-dropdown-item">
                      About
                    </Link>
                    <Link to="/blog" className="custom-dropdown-item">
                      Blogs
                    </Link>
                    
                  </div>
                </div>

                {categories.map((cat) => (
                  <div className="custom-nav-dropdown" key={cat._id}>
                    <Nav.Link
                      as={Link}
                      to={`/categories/${cat.slugPath}`}
                      className="custom-header-link"
                    >
                      {cat.name}
                    </Nav.Link>

                    {cat.children && cat.children.length > 0 && (
                      <div className="custom-dropdown-menu">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="custom-dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
                 <Nav.Link
                  as={Link}
                  to="/shop"
                  className="custom-header-link d-none d-lg-flex"
                >
                 All Products
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className="custom-header-link d-none d-lg-flex"
                >
                  Contact
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/customize"
                  className="custom-header-link d-none d-lg-flex"
                >
                  Customize
                </Nav.Link>
              </div>
            </div>

            <div className="col-3 col-lg-3 d-flex justify-content-end align-items-center gap-2 gap-md-4">
              <button
                className="btn p-0 d-lg-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileMenu"
              >
                <Menu size={24} strokeWidth={1.5} />
              </button>
              <div className="custom-header-search-box d-none d-lg-block">
                <InputGroup className="border-bottom border-dark">
                  <Form.Control
                    placeholder="Search Suits..."
                    className="border-0 shadow-none header-search-input"
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      setShowSearchModal(true);
                    }}
                  />
                  <Search size={18} className="search-icon" />
                </InputGroup>
                <SearchCanvas
                  isOpen={showSearchModal}
                  searchText={searchText}
                  setSearchText={setSearchText}
                />
              </div>
              <Link to="/wishlist" className="d-block text-decoration-none">
                <Heart size={20} className="text-dark" strokeWidth={1.5} />
              </Link>

              {isLoggedIn ? (
                <Link
                  to="/users/dashboard"
                  className="btn p-0 d-none d-lg-block"
                >
                  <User size={20} className="text-dark" strokeWidth={1.5} />
                </Link>
              ) : (
                <Link to="/users/login" className="btn p-0 d-none d-lg-block">
                  <User size={20} className="text-dark" strokeWidth={1.5} />
                </Link>
              )}

              <button
                data-bs-toggle="offcanvas"
                data-bs-target="#shoppingCartCanvas"
                className="btn p-0 position-relative"
              >
                <ShoppingBag size={22} strokeWidth={1.5} />
                <span
                  className="position-absolute top-0 start-100 translate-middle badge rounded-circle bg-dark"
                  style={{ fontSize: "7px", padding: "4px 6px" }}
                >
                  {cartItems.length}
                </span>
              </button>
            </div>
          </div>
        </div>

        <div className="custom-header-search-box d-block d-lg-none p-1 bg-muted">
          <InputGroup className="border-bottom border-dark">
            <Form.Control
              placeholder="Search Suits..."
              className="border-0 shadow-none header-search-input"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setShowSearchModal(true);
              }}
            />
            <Search size={18} className="search-icon" />
          </InputGroup>
          <SearchCanvas
            isOpen={showSearchModal}
            searchText={searchText}
            setSearchText={setSearchText}
          />
        </div>
      </header>

      <SearchCanvas
        isOpen={showSearchModal}
        searchText={searchText}
        setSearchText={setSearchText}
        onClose={() => setShowSearchModal(false)}
      />

      <div
        className="offcanvas offcanvas-end custom-cart-offcanvas"
        id="shoppingCartCanvas"
      >
        <CartCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="loginOffCanvas"
      >
        <LoginCanvas />
      </div>

      <div
        className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
        id="registerOffCanvas"
      >
        <RegisterCanvas />
      </div>

    
    
    
    
    
    
      <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
        <button
          className="icon-close icon-close-popup"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
        <div className="mb-canvas-content">
          <div className="mb-body">
            <div className="mb-content-top">
              <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                <li className="nav-mb-item">
                  <Link to="/" className="mb-menu-link">
                    Home
                  </Link>
                </li>
                <li className="nav-mb-item">
                  <Link to="/about-us" className="mb-menu-link">
                    About Us
                  </Link>
                </li>
                 {/* <li className="nav-mb-item">
                  <Link to="/shop" className="mb-menu-link">
                  Shop
                  </Link>
                </li> */}
                 <li className="nav-mb-item">
                  <Link to="/blog" className="mb-menu-link">
                  Blog
                  </Link>
                </li>
                <li className="nav-mb-item">
                  <Link to="/shop" className="mb-menu-link">
                    All Products
                  </Link>
                </li>

                {/* {categories.map((cat) => (
                  <li className="nav-mb-item" key={cat._id}>
                    <div
                      className="mb-menu-link nav-item-dropdown d-flex justify-content-between"
                      onClick={() => handleToggle(cat._id)}
                    >
                      {cat.name}
                      <span>{openId === cat._id ? "-" : "+"}</span>
                    </div>
                    {cat.children?.length > 0 && openId === cat._id && (
                      <div className="dropdown-menu show">
                        {cat.children.map((sub) => (
                          <Link
                            key={sub._id}
                            to={`/categories/${sub.slugPath}`}
                            className="dropdown-item"
                          >
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </li>
                ))} */}


              {categories.map((cat) => (
  <li className="nav-mb-item" key={cat._id}>
    <div className="mb-menu-link nav-item-dropdown d-flex justify-content-between align-items-center">

      {/* Category → Category Page */}
      <Link
        to={`/categories/${cat.slugPath}`}
        className="text-decoration-none flex-grow-1   custom-small-catg"
      >
        {cat.name}
      </Link>

      {/* + / - → Open Subcategories */}
      {cat.children?.length > 0 && (
        <span
          role="button"
          onClick={() => handleToggle(cat._id)}
          className="ms-2"
        >
          {openId === cat._id ? "-" : "+"}
        </span>
      )}
    </div>

    {/* Subcategories */}
    {cat.children?.length > 0 && openId === cat._id && (
      <div className="dropdown-menu show">
        {cat.children.map((sub) => (
          <Link
            key={sub._id}
            to={`/categories/${sub.slugPath}`}
            className="dropdown-item"
          >
            {sub.name}
          </Link>
        ))}
      </div>
    )}
  </li>
))}



                <li className="nav-mb-item">
                  <Link to="/contact-us" className="mb-menu-link">
                    Contact
                  </Link>
                </li>
                 <li className="nav-mb-item">
                  <Link to="/customize" className="mb-menu-link">
                    Customize
                  </Link>
                </li>
              </ul>
            </div>
            <div className="mb-other-content">
              <div className="group-icon">
                {!isLoggedIn ? (
                  <Link to="/users/login" className="shop-btn">
                    <i className="icon icon-user me-2" /> Login
                  </Link>
                ) : (
                  <Link to="/users/dashboard" className="shop-btn">
                    <i className="icon icon-user me-2" /> Dashboard
                  </Link>
                )}
              </div>
              <div className="mb-contact mb-0 border-bottom border-muted">
                <p>
                  Address:
                  <span className="ms-1">
                    {[
                      config?.address?.addressLine,
                      config?.address?.district,
                      config?.address?.state,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                    {config?.address?.pincode
                      ? ` - ${config?.address.pincode}`
                      : ""}
                  </span>
                </p>
              </div>
              <ul className="pt-3">
                <li>
                  Email:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`mailto: ${config.email}`}
                    >
                      {config.email}
                    </a>
                  </b>
                </li>
                <li>
                  Phone:
                  <b className="fw-medium">
                    <a
                      className="text-decoration-none text-secondary"
                      href={`tel: ${config.phone}`}
                    >
                      +91-{config.phone}
                    </a>
                  </b>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
